import { checkNullish } from '../../helpers/checkNullish';

export const readPostKey = 'read_post';
export const chooseHashtagKey = 'selectedTopic';

export const setPostVisitorRead = (postId: string) => {
  const arrayFromLocalStorage: string = checkNullish(
    localStorage.getItem(readPostKey)
  );
  if (arrayFromLocalStorage) {
    let postIdArray: string[] = JSON.parse(arrayFromLocalStorage);
    if (postIdArray.every((item) => item !== postId)) {
      postIdArray = postIdArray.concat([postId]);
      localStorage.setItem(readPostKey, JSON.stringify(postIdArray));
    }
    return;
  }
  localStorage.setItem(readPostKey, JSON.stringify([postId]));
};

export const getPostVisitorRead = () => {
  const arrayFromLocalStorage: string = checkNullish(
    localStorage.getItem(readPostKey)
  );
  return arrayFromLocalStorage ? JSON.parse(arrayFromLocalStorage) : [];
};

export const getHashtagsVisitorChoose = () => {
  const arrayFromLocalStorage: string = checkNullish(
    localStorage.getItem(chooseHashtagKey)
  );
  return arrayFromLocalStorage ? JSON.parse(arrayFromLocalStorage) : [];
};
